export default "__VITE_ASSET__22a852a3__"